/* eslint-disable react/display-name, react-hooks/exhaustive-deps */
import { createElement, useEffect } from "react"
import type { FC, ReactElement } from "react"

import { useProjectVersionMismatch } from "@/3514/hooks"
import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { type TAppDispatcher, useAppDispatcher } from "@/3514/store/app"
import type { TEmptyRenderCallback } from "@/shared/types/functions"

function withProductTypeGuard(MainComponent: FC): TEmptyRenderCallback {
    return (): ReactElement => {
        const { initApp }: TAppDispatcher = useAppDispatcher()

        const { isSuccess }: TProductTypeQuery = useProductTypeQuery()

        useProjectVersionMismatch()

        useEffect((): void => {
            if (isSuccess) initApp()
        }, [isSuccess])

        return createElement(MainComponent)
    }
}

export { withProductTypeGuard }
